import { Translation } from '../types/i18n';

export const en: Translation = {
  modeToggle: {
    cubeMode: '🧩 Cube Mode',
    speedcubing: '⏱️ Speedcubing',
    hint: '💡 Press Tab to switch modes',
  },

  keyGuide: {
    title: '⌨️ Key Guide',
    open: 'Open Key Guide',
    close: 'Close Key Guide',
    sections: {
      cubeControl: '🎮 Cube Control',
      camera: '📹 Camera',
      system: '⚡ System',
      controls: '🎛️ Controls',
    },
    keys: {
      frontRotate: 'Front Face Rotation',
      upRotate: 'Up Face Rotation',
      backRotate: 'Back Face Rotation',
      leftRotate: 'Left Face Rotation',
      downRotate: 'Down Face Rotation',
      rightRotate: 'Right Face Rotation',
      cubeTilt: 'Tilt Cube 90°',
      counterClockwise: 'Counter-clockwise Rotation',
      counterClockwiseHint: '💡 e.g., Shift+Q = Front\' (counter-clockwise)',
      prevCorner: 'Previous Corner',
      nextCorner: 'Next Corner',
      topView: 'Top View',
      timerStartStop: 'Start/Stop Timer',
      modeSwitch: 'Switch Mode',
      shuffle: 'Shuffle Cube',
      reset: 'Reset Cube',
      undo: 'Undo',
      redo: 'Redo',
      speedDecrease: 'Decrease Animation Speed',
      speedIncrease: 'Increase Animation Speed',
      zoomOut: 'Zoom Out',
      zoomIn: 'Zoom In',
    },
    scrollHint: '↓ More Shortcuts ↓',
  },

  historyBar: {
    clear: 'Clear History',
    empty: 'No move history',
  },

  rankingPanel: {
    title: '🏆 Rankings',
    open: 'Open Rankings Panel',
    close: 'Close Rankings Panel',
    tabs: {
      all: 'All',
      my: 'My Records',
    },
    columns: {
      rank: 'Rank',
      nickname: 'Nickname',
      time: 'Time',
      moves: 'Moves',
      date: 'Date',
    },
    noRecords: 'No records yet',
    loading: 'Loading records...',
    error: 'Failed to load rankings.',
    retry: 'Retry',
    refresh: 'Refresh',
    stats: {
      totalRecords: 'Total Records',
      bestRecord: 'Best Record',
      recordsUnit: '',
    },
  },

  nicknameModal: {
    title: 'Cube Solved!',
    subtitle: 'Would you like to save your record?',
    placeholder: 'Enter nickname (2-20 characters)',
    confirm: 'Save',
    skip: 'Skip',
    saving: 'Saving...',
    errors: {
      required: 'Please enter a nickname.',
      tooShort: 'Nickname must be at least 2 characters.',
      tooLong: 'Nickname must be 20 characters or less.',
      invalidChars: 'Special characters are not allowed.',
      saveFailed: 'An error occurred while saving the record.',
      supabaseFailed: 'Failed to save to online rankings, but saved to local records.',
    },
    success: '✅ Record saved successfully!',
    note: '⚠️ Your record will be saved to both local and online rankings.',
  },

  shuffleModal: {
    title: '🎲 Shuffle Cube',
    message: 'Do you want to shuffle the cube?',
    confirm: 'Shuffle',
    cancel: 'Cancel',
  },

  colorSettings: {
    title: '🎨 Color Settings',
    presets: 'Presets',
    custom: 'Custom',
    faces: {
      up: 'Up',
      right: 'Right',
      front: 'Front',
      down: 'Down',
      left: 'Left',
      back: 'Back',
    },
    apply: 'Apply',
    close: 'Close',
    presetNames: {
      standard: 'Standard',
      'high-contrast': 'High Contrast',
      distinct: 'Distinct',
      vivid: 'Vivid',
      matte: 'Matte',
      classic: 'Classic',
      retro: 'Retro',
    },
    presetDescriptions: {
      standard: 'Default color scheme',
      'high-contrast': 'Enhanced orange/red distinction',
      distinct: 'Optimized for color differentiation',
      vivid: 'Clearly distinguishable colors',
      matte: 'Subtle yet distinct colors',
      classic: 'Traditional primary colors',
      retro: '80s style with clear distinction',
    },
  },

  cameraMinimap: {
    title: '📹 Camera View',
    open: 'Open Camera Panel',
    close: 'Close Camera Panel',
    speed: '⚡ Animation Speed',
    zoom: '🔍 Zoom',
    colors: 'Color Settings',
    speedHint: '💡 Lower animation speed allows faster cube manipulation',
    legend: {
      upper: 'Upper',
      lower: 'Lower',
      current: 'Current',
    },
    navigation: {
      title: 'Corner Navigation:',
      opposite: 'Opposite Corner',
      prev: 'Prev Corner',
      next: 'Next Corner',
      toggle: 'Toggle Level',
    },
  },

  speedHint: {
    title: 'Pro Tip',
    message: 'Lower animation speed allows faster cube manipulation',
    dismiss: 'Dismiss',
  },

  timer: {
    ready: 'Ready!',
    locked: '🔒 Cube Locked',
    inspection: 'Inspection',
  },

  footer: {
    portfolio: 'Portfolio',
    github: 'Github',
    rights: '© 2025 Kuneosu. All rights reserved.',
  },

  languageDialog: {
    title: 'Language Selection',
    subtitle: 'Please select your language',
    korean: '한국어',
    english: 'English',
  },
};
